import script from "./school-layout.vue?vue&type=script&setup=true&lang=js"
export * from "./school-layout.vue?vue&type=script&setup=true&lang=js"

import "./school-layout.vue?vue&type=style&index=0&id=b8ea7822&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/map/markers/school-layout.vue'],['__file',"school-layout.vue"]])

export default __exports__